module.exports = __webpack_public_path__ + "static/media/kuehlregal.f931f2cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/food-store/kuehlregal.png
// module id = 503
// module chunks = 0